import React from 'react';
import {
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import axios from '../services/axios';
import Box from '@mui/material/Box';
import { registerWithEmailAndPasswordStudent } from '../repo/firebase';

const AddUser = () => {
  const [userType, setUserType] = React.useState('STUDENT');
  const classesData = [
    'CLASS V',
    'CLASS VI',
    'CLASS VII',
    'CLASS VIII',
    'CLASS IX',
    'CLASS X',
    'CLASS XI',
    'CLASS XII',
  ];

  const [userData, setUserData] = React.useState({
    name: '',
    email: '',
    role: 'STUDENT',
    dob: '',
    class: '',
    gender: '',
    sponser: '',
    anualIncome: '',
    disability:'',
    noOfSiblings:'',
    distanceSchool:'',
    DrinkingWater:'',
    ToiletFacility:'',
    preveiousPregnancy:'',
    transportFacility: '',
    precentage: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

    if (name === 'role') setUserType(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userData.password !== userData.confirmPassword)
      return alert('Passwords do not match');

      try {
        registerWithEmailAndPasswordStudent(userData.name, userData.email,userData.password,userData.class,userData.dob,userData.sponser,userData.gender,userData.anualIncome, userData.disability, userData.noOfSiblings, userData.distanceSchool, userData.ToiletFacility, userData.DrinkingWater,userData.preveiousPregnancy,userData.precentage).then((res) => {
         })
  
      } catch (error) {
       
        return alert('Something went wrong, please try again later');
      }
  };

  return (
    <Box>
      <div heading={'Add User'}>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '40%',
              padding: '10px',
              margin: 'auto',
            }}
          >
            <h2
              style={{
                alignText: 'center',
                paddingTop: '18px',
                paddingBottom: '18px',
                textAlign: 'center',
                backgroundColor: '#3f51b5',
                color: 'white',
              }}
            >
              Register new user
            </h2>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <MenuItem value='STUDENT'> Student</MenuItem>
            </FormControl>

            {userType === 'STUDENT' && (
              <FormControl
                fullWidth
                style={{
                  marginBottom: '10px',
                }}
              >
                <InputLabel id='demo-simple-select-label'>
                  Sponsorship
                </InputLabel>
                <Select
                  id='sponsorship'
                  name='sponsorship'
                  label='Sponsorship'
                  onChange={handleChange}
                  required
                >
                  <MenuItem value='SELF'>Self Sponsored</MenuItem>
                  <MenuItem value='GOVERNMENT'>Government Sponsored</MenuItem>
                  <MenuItem value='OTHER'>Other sponsorship</MenuItem>
                </Select>
              </FormControl>
            )}

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>Class</InputLabel>
              <Select
                id='class'
                name='class'
                label='Class'
                onChange={handleChange}
              >
                {
                  //loop over classesData and return a MenuItem for each class
                  classesData.map((classData) => {
                    return <MenuItem value={classData}>{classData}</MenuItem>;
                  })
                }
              </Select>
            </FormControl>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='password'
                name='password'
                label='Password'
                variant='outlined'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <div
              style={{
                marginBottom: '10px',
                width: '100%',
              }}
            >
              <TextField
                id='confirmPassword'
                name='confirmPassword'
                label='Confirm password'
                variant='outlined'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                fullWidth
                id='name'
                name='name'
                label='Name'
                variant='outlined'
                required
                onChange={handleChange}
              />
            </div>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='email'
                name='email'
                type='email'
                label='Email'
                variant='outlined'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='percentage'
              name='percentage'
              type='text'
              label='Previous Class Percentage'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />
          </div>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>Gender</InputLabel>
              <Select
                id='gender'
                name='gender'
                label='Gender'
                onChange={handleChange}
              >
                <MenuItem value='MALE'>Male</MenuItem>
                <MenuItem value='FEMALE'>Female</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='familyAnnualIncome'
                name='familyAnnualIncome'
                variant='outlined'
                fullWidth
                required
                type='number'
                label='Family Annual Income (KES)'
                onChange={handleChange}
              />
            </FormControl>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='dob'
                name='dob'
                label='Date of birth'
                variant='outlined'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>Disability</InputLabel>
              <Select
                id='disability'
                name='disability'
                label='Disability'
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='siblings'
                name='siblings'
                type='number'
                label='No. of siblings'
                variant='outlined'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <TextField
                id='distance'
                name='distance'
                label='Distance from school (km)'
                variant='outlined'
                type='number'
                fullWidth
                required
                onChange={handleChange}
              />
            </div>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>
                Drinking water facilities
              </InputLabel>
              <Select
                id='transportFacility'
                name='transportFacility'
                label='Transport  facilities'
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>
                Toilet facilities
              </InputLabel>
              <Select
                id='toiletFacility'
                name='toiletFacility'
                label='Toilet Facility'
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>
                Drinking water facilities
              </InputLabel>
              <Select
                id='drinkingWater'
                name='drinkingWater'
                label='Drinking water facilities'
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
              <InputLabel id='demo-simple-select-label'>
                Previous pregnancy
              </InputLabel>
              <Select
                id='pregnancy'
                name='pregnancy'
                label='Previous pregnancy'
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>

            <Button type='submit' variant='contained'>
              Submit
            </Button>
          </div>
        </form>
      </div>
    </Box>
  );
};

export default AddUser;
